export default {
  PAYMENTS_USD_REQUEST: 'PAYMENTS_USD_REQUEST',
  PAYMENTS_USD_SUCCESS: 'PAYMENTS_USD_SUCCESS',
  PAYMENTS_USD_FAILURE: 'PAYMENTS_USD_FAILURE',
};